import debug from "debug";

import plugin from '../../lib/plugin';
const MODULE_NAME = 'core/modules/user-needs-modal';
const log = debug(MODULE_NAME);


const MODAL_SELECTOR = '#user-needs-mode-modal';
const BUTTON_SELECTOR = '[data-change-mode]';
const CHANGE_MODE_ATTR = 'data-change-mode';
const ELEMENT_SELECTOR = '[data-user-needs-mode-modal]';
const CLOSE_BUTTON_SELECTOR = '[data-close]';

class UserNeedsModalPlugin {
    constructor(element, options) {
        this.options = options;
        this.element = element;
        this.$element = $(element);
        this.buttons = this.$element.find(BUTTON_SELECTOR);

        var self = this;

        $.each(this.buttons, function(index, value) {
            $(this).click(function() {
        		var mode = $(this).attr(CHANGE_MODE_ATTR);
                self.handleButtonClick(mode);
            });
        });

        $(function () {
            const $modal = $(MODAL_SELECTOR);
            if (!$modal.length) {
                log('Modal is absent');
                return false;
            }
            self.openModal($modal);
        });
    }

    handleButtonClick(mode) {
    	this.setMode(mode);
        this.closeModal();
    }

    setMode(mode) {
        this.post(mode);
    }

    closeModal() {
        const $modal = $(MODAL_SELECTOR);
        $modal.foundation('close');
    }

    openModal(modal) {
        modal.foundation('open');
    }

    post(mode) {
        var endpointUrl = this.options.endpointUrl;
        // var url = endpointUrl;
        var url = `${endpointUrl}?${this.options.endpointParam}=${mode}`;

        var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();

        $.ajax({
            url,
            method: 'post',
            data: {
                _RequestVerificationToken: token
            },
            success: result => {
                this.onSuccess(result);
            },
            error: e=> {
                log('userNeedsModeAjaxError', e);
            }
        }).done(() => {
            log('accepted', this.$element, url);
        });
    }

    onSuccess(result) {
        var page_y =  $(window).scrollTop();
     	this.setLocationScrollPositionCookie(page_y);
        location.reload();
    }

    setLocationScrollPositionCookie(scrollPos) {
    	var cname = this.options.locationScrollPositionCookieName;
    	var cvalue = scrollPos;
    	var d = new Date();
	    d.setTime(d.getTime() + (1*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}

plugin('setUserMode', UserNeedsModalPlugin);

export function exec() {

    $(document).ready(() => {
        $(ELEMENT_SELECTOR).setUserMode();
    });
}

UserNeedsModalPlugin.DEFAULTS = {
    endpointUrl: $(`meta[name="site.setUserNeedsModeApiEndpoint"]`).attr('content'),
    endpointParam: 'mode'
};





// WEBPACK FOOTER //
// ./client/src/core/modules/user-needs-modal/index.js